/**
 * How an order names the person it is for.
 *
 * The customer is who the shop deals with and who pays, so their name leads.
 * What follows says the clothes are not theirs: "Rahul Sharma (For Brother)".
 *
 * The relation is what the counter actually says out loud, so it is preferred.
 * Where none was given, the person's own name stands in rather than leaving an
 * empty bracket — "Rahul Sharma (For Aarav)" still tells the truth.
 */

const title = (s) => {
  const t = String(s || '').trim();
  return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
};

/** "For Brother", or null when the order is the customer's own. */
export function forWhom(familyMember) {
  if (!familyMember) return null;
  const who = title(familyMember.relation) || title(familyMember.name);
  return who ? `For ${who}` : null;
}

/**
 * The whole label: the customer, and who the clothes are for.
 * @param {{name?: string}} customer
 * @param {{name?: string, relation?: string}|null} familyMember
 */
export function orderForLabel(customer, familyMember) {
  const name = customer?.name || '—';
  const tail = forWhom(familyMember);
  return tail ? `${name} (${tail})` : name;
}

export default orderForLabel;
